import { defineComponent as _defineComponent } from 'vue'
import { type DataInstance, type Organizations } from "@/platform-data";

type Props = {
	organization:  DataInstance<Organizations.Model>
	state: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'detail-view',
  props: {
    organization: {},
    state: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;



const unwantedFields = ['$id', 'org_id', 'Logo', 'Social Media Handles', 'lat', 'lng']

function cleanOrganizationData(organization: DataInstance<Organizations.Model>) {
	const cleanedOrg: Partial<Organizations.Model> = {};
	for (const key in organization) {
		const fieldVal =  organization[key as keyof Organizations.Model]
		if(fieldVal !== null && fieldVal !== undefined && !unwantedFields.includes(key)){
			let val = fieldVal;
			if(val === true){
				val = "yes"
			}else if(val === false){
				val = "no"
			}
			cleanedOrg[key as keyof Organizations.Model] = val;
		}else if(key === 'SocialHandles'){
			for(const key in organization["Social Media Handles"]){
				const social = organization["Social Media Handles"][key as keyof Organizations.Model["Social Media Handles"]];
				if(social !== null && social !== ""){
					cleanedOrg[key] = social
				}
			}
		}
	}

	return cleanedOrg;
}




const __returned__ = { props, unwantedFields, cleanOrganizationData }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})